<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Order Cases</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :hideBranch="true"
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :columns="columns"
          :showHideColumn="showHideColumn"
          :filterMade="filterMade"
          :totalResult="totalResult"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              sm9
              md9
              lg6
              class="px-2"
            >
              <v-select
                :items="statusList"
                v-model="tableData.statuses"
                label="Statuses"
                multiple
                chips
                hide-details
                deletable-chips
              />
            </v-flex>
            <v-flex
              xs12
              sm3
              md3
              lg6
              class="px-2 pt-3"
            >
              <v-btn
                color="primary"
                style="height: auto; transition: all 0.1s"
                class="pa-1"
                depressed
                small
                @click="getResults()"
              >
                Search
              </v-btn>
            </v-flex>
          </v-layout>
          <datatable
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_case_id"
                :class="{
                  'orange lighten-2': r.status == 2,
                  'red lighten-2': r.status == 3,
                  'blue lighten-2': r.status == 4,
                }"
              >
                <td>{{ r.order_case_id }}</td>
                <td>{{ r.status_name }}</td>
                <td>{{ r.theOrderID }}</td>
                <td>{{ r.full_name }}</td>
                <td>{{ r.customer_name }}</td>
                <td class="customer-note-color"> {{ r.customer_note }} </td>
                <td>{{ r.customer_phone }}</td>
                <td>{{ r.product_name }}</td>
                <td>{{ r.note }}</td>
                <td>{{ r.created_at | moment('YYYY-MM-DD hh:mm a') }}</td>
                <td>
                  <div class="d-flex">
                    <comment
                      v-if="$_has_perm('comment_order_case')"
                      :modelId="r.order_case_id"
                      modelName="Order Case"
                      class="px-2"
                      :title="`Order Case #${r.order_case_id} Comments`"
                    />
                    <a
                      v-if="$_has_perm('send_to_staff_order_case') && [1,2].includes(r.status)"
                      tooltip="Send to staff"
                      class="px-2"
                      @click="sendToStaff(r)"
                    >
                      <v-icon color="success darken-2">send</v-icon>
                    </a>
                    <a
                      v-if="$_has_perm('process_order_case') && r.status == 1"
                      tooltip="Process"
                      class="px-2"
                      @click="process(r.order_case_id)"
                    >
                      <i
                        class="fa fa-cog warning--text"
                        style="font-size: 22px"
                      />
                    </a>
                    <a
                      v-if="$_has_perm('refund_order_case') && [1,2].includes(r.status)"
                      tooltip="Refund"
                      class="px-2"
                      @click="refund(r.order_case_id)"
                    >
                      <i class="material-icons error--text">block</i>
                    </a>
                    <a
                      v-if="$_has_perm('replace_order_case') && r.status == 2"
                      tooltip="Replace"
                      class="px-2"
                      @click="replace(r.order_case_id)"
                    >
                      <i
                        class="fa fa-refresh info--text"
                        style="font-size: 22px"
                      />
                    </a>
                    <a
                      v-if="[1,2].includes(r.status)"
                      tooltip="Images"
                      class="px-2"
                      @click="showCaseFiles(r)"
                    >
                      <i
                        class="fa fa-image grey--text text--darken-2"
                        style="font-size: 22px"
                      />
                    </a>
                    <!-- <a
                      v-if="$_has_perm('delete_order_case') && r.status == 1"
                      tooltip="Trash"
                      class="px-2"
                      @click="deleteRow(r.order_case_id)"
                    >
                      <i
                        class="fa fa-trash error--text"
                        style="font-size: 22px"
                      />
                    </a> -->
                  </div>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <add-edit-order-case
            :addEditOrderCaseModal="addEditOrderCaseModal"
            :formData="formData"
            :isUpdate="isUpdate"
            @close="addEditOrderCaseModal = false"
            @resetTable="resetGetResults()"
          />

          <send-to-staff
            :sendToStaffModal="sendToStaffModal"
            :formData="formData"
            :staffList="staffList"
            @close="sendToStaffModal = false"
            @resetTable="resetGetResults()"
          />

          <order-case-files
            :formData="formData"
            :orderCaseFileModal="orderCaseFileModal"
            @close="orderCaseFileModal = false"
          />

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../Pagination.vue'
import preDatatableComponent from '../preDatatableComponent.vue'
import DatatableVue from '../Datatable.vue'
import addEditOrderCase from './addEditOrderCase'
import sendToStaff from './sendToStaff.vue'
import orderCaseFiles from './orderCaseFiles.vue'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    addEditOrderCase,
    sendToStaff,
    orderCaseFiles
  },

  mounted() {
    this.perPageFix()
    this.getStaffList()
    this.getWarehouses()
  },

  $_veeValidate: {
    validator: 'new'
  },

  data() {
    let sortOrders = {}
    let columns = [
      { label: 'Case ID', text: 'Case ID', value: '1', sortable: true, searchable: true, name: 'order_case_id' },
      { label: 'Status', text: 'Status', value: '2', sortable: true, searchable: true, name: 'status_name' },
      { label: 'Order ID', text: 'Order ID', value: '3', sortable: true, searchable: true, name: 'theOrderID' },
      { label: 'Created By', text: 'Created By', value: '4', sortable: true, searchable: true, name: 'full_name' },
      { label: 'Customer Name', text: 'Customer Name', value: '5', sortable: true, searchable: true, name: 'customer_name' },
      { label: 'Customer Note', text: 'Customer Note', value: '6', sortable: true, searchable: true, name: 'customer_note' },
      { label: 'Customer Phone', text: 'Customer Phone', value: '7', sortable: true, searchable: true, name: 'phone_number' },
      { label: 'Product Name', text: 'Product Name', value: '8', sortable: true, searchable: true, name: 'product_name' },
      { label: 'Note', text: 'Note', value: '9', sortable: true, searchable: true, name: 'note' },
      { label: 'Create Date', text: 'Create Date', value: '10', sortable: true, searchable: true, name: 'created_at' }
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      url: 'api/order-case',
      alertValue: false,
      filterMade: false,
      totalResult: 0,
      isUpdate: false,
      addEditOrderCaseModal: false,
      prevSearchQuery: '',
      apiResults: [],
      formData: {},
      sendToStaffModal: false,
      orderCaseFileModal: false,
      staffList: [],
      warehouses: [],
      columns: columns,
      statusList: [
        { text: 'Pending', value: 1 },
        { text: 'Processing', value: 2 },
        { text: 'Refund', value: 3 },
        { text: 'Replace', value: 4 }
      ],
      sortKey: 'order_case_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'order_case_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    getStaffList() {
      let token = localStorage.getItem('access_token')

      axios
        .get('api/get-staff-list', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          response.data.forEach((c) => {
            this.staffList.push({
              text: c.full_name + ' - Tel: ' + c.phone_number,
              value: c.user_id
            })
          })
        })
    },

    getWarehouses() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/warehouses', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          response.data.data.forEach((r) => {
            this.warehouses.push({ text: r.country, value: r.warehouse_id, transportation_types: r.transportation_types })
          })
        })
    },

    showHideColumn(prevColVal, currentColVal) {
      let a = []
      let diff = []

      if (currentColVal.length < prevColVal.length) {
        for (let i = 0; i < prevColVal.length; i++) {
          a[prevColVal[i]] = true
        }

        for (let i = 0; i < currentColVal.length; i++) {
          if (a[currentColVal[i]]) {
            delete a[currentColVal[i]]
          } else {
            a[currentColVal[i]] = true
          }
        }

        for (let k in a) {
          diff.push(k)
        }

        for (let c = 0; c < diff.length; c++) {
          $('td:nth-child(' + diff[c] + '),th:nth-child(' + diff[c] + ')').toggle()
        }
      } else {
        for (let i = 0; i < currentColVal.length; i++) {
          let visible = $(
            'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
          ).is(':visible')
          if (visible) {
            $(
              'td:nth-child(' + currentColVal[i] + '),th:nth-child(' + currentColVal[i] + ')'
            ).toggle()
          }
        }
      }
    },

    showCaseFiles(data) {
      this.formData = { ...data }
      this.orderCaseFileModal = true
    },

    edit(data) {
      this.formData = { ...data }
      this.isUpdate = true
      this.addEditOrderCaseModal = true
    },

    // deleteRow(id) {
    //   swal({
    //     title: 'Are you sure?',
    //     icon: 'warning',
    //     buttons: true
    //   }).then(willDelete => {
    //     if (willDelete) {
    //       let token = localStorage.getItem('access_token')
    //       axios
    //         .delete(`api/order-case/${id}`, { headers: { Authorization: 'Bearer ' + token } })
    //         .then(() => {
    //           this.getResults()
    //           swal({
    //             title: 'Done',
    //             text: '',
    //             icon: 'success',
    //             timer: 1500,
    //             buttons: false
    //           })
    //         })
    //     }
    //   })
    // },

    sendToStaff(data) {
      this.formData = {
        order_case_id_fk: data.order_case_id,
        user_id_fk: null,
        theOrderID: data.theOrderID,
        full_name: data.full_name,
        deadline: null
      }
      this.sendToStaffModal = true
    },

    process(id) {
      swal({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .put(`api/order-case/${id}/process`, {}, { headers: { Authorization: 'Bearer ' + token } })
            .then(() => {
              this.getResults()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
        }
      })
    },

    refund(id) {
      swal({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .put(`api/order-case/${id}/refund`, {}, { headers: { Authorization: 'Bearer ' + token } })
            .then(() => {
              this.getResults()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
        }
      })
    },

    replace(id) {
      swal({
        title: 'Are you sure?',
        icon: 'warning',
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .put(`api/order-case/${id}/replace`, {}, { headers: { Authorization: 'Bearer ' + token } })
            .then(() => {
              this.getResults()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
        }
      })
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          if (data.data.length > 0) {
            this.filterMade = true
            this.apiResults = data.data
          } else {
            this.filterMade = false
            this.apiResults = data.data.data
          }

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          if (data.data.length > 0) {
            this.removeConfigPagination()
          } else {
            this.configPagination(data.data)
          }
          theDatatable.classList.remove('slide-table-out')
          setTimeout(() => {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .then(() => {
          this.totalResult = 0
          for (let i = 0; i < this.apiResults.length; i++) {
            this.totalResult += 1
          }
        })
        .catch(error => {
          swal(`${error.response.data.message}`, '', 'error')
        })
    },

    removeConfigPagination() {
      this.pagination.lastPage = ''
      this.pagination.currentPage = ''
      this.pagination.total = ''
      this.pagination.lastPageUrl = ''
      this.pagination.nextPageUrl = ''
      this.pagination.prevPageUrl = ''
      this.pagination.from = ''
      this.pagination.to = ''
    },

    resetGetResults() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'order_case_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'order_case_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    resetGetResults2() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'order_case_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'order_case_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden;
  overflow-y: hidden;
}

a {
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 0%;
  bottom: 110%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}
</style>



// WEBPACK FOOTER //
// src/components/orderCase/orderCases.vue